import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { getVerifyAccountCTA } from "./shared";
export var WhyOrderOnHoldIA = function WhyOrderOnHoldIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getVerifyAccountCTA;
        return (_getVerifyAccountCTA = getVerifyAccountCTA(context, strictLocalize)) === null || _getVerifyAccountCTA === void 0 ? void 0 : _getVerifyAccountCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getVerifyAccountCTA2, _getVerifyAccountCTA3;
        return (_getVerifyAccountCTA2 = getVerifyAccountCTA(context, strictLocalize)) === null || _getVerifyAccountCTA2 === void 0 ? void 0 : (_getVerifyAccountCTA3 = _getVerifyAccountCTA2.getLink) === null || _getVerifyAccountCTA3 === void 0 ? void 0 : _getVerifyAccountCTA3.call(_getVerifyAccountCTA2);
      }
    },
    learnMoreLink: articles !== null && articles !== void 0 && articles.MyOrders.BUSINESS_PROFILE ? articlePage(articles.MyOrders.BUSINESS_PROFILE.id) : undefined
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return VERIFY_YOUR_ACCOUNT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [WE_NEED_MORE_INFO_TO_VERIFY_YOUR_ACCOUNT(strictLocalize), WE_WILL_REVIEW_YOUR_INFO(strictLocalize)];
    }
  };
};
var VERIFY_YOUR_ACCOUNT = function VERIFY_YOUR_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "5sXjG1",
    defaultMessage: [{
      "type": 0,
      "value": "Verifieer je account om je bestelling te voltooien"
    }]
  });
};
var WE_NEED_MORE_INFO_TO_VERIFY_YOUR_ACCOUNT = function WE_NEED_MORE_INFO_TO_VERIFY_YOUR_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "LRfQ+e",
    defaultMessage: [{
      "type": 0,
      "value": "We willen dat je je bestelling zo snel mogelijk ontvangt. We hebben gewoon wat meer informatie nodig om je account te verifiëren. Je hoeft dit maar één keer te doen."
    }]
  });
};
var WE_WILL_REVIEW_YOUR_INFO = function WE_WILL_REVIEW_YOUR_INFO(strictLocalize) {
  return strictLocalize({
    id: "K01U+6",
    defaultMessage: [{
      "type": 0,
      "value": "Zodra we je gegevens hebben ontvangen, controleren we deze. We reageren meestal binnen 1 werkdag."
    }]
  });
};